import SearchResultsCard from '../../../ui/search-result-card/SearchResultsCard';
import { sortByWeightAndAlphabetical } from '../utils/sort-by-weight-and-alphabetical';
import c from '../category-new.module.scss';

export const PopularLinks = ({ links, categoryId }) => {
  const pinnedLinks = links
    .map((link) => {
      const currentFoundCategory = link.categories?.find(
        (c) => c.id === categoryId
      );
      const isPinned = Boolean(currentFoundCategory?.pinned);

      if (!isPinned) return null;

      return {
        ...link,
        _pinnedWeight: currentFoundCategory.weight ?? 10,
      };
    })
    .filter((link) => link !== null);

  const sortedPinnedLinks = sortByWeightAndAlphabetical({
    list: pinnedLinks,
    weightKey: '_pinnedWeight',
    alphabeticalKey: 'name',
  });

  const hasPinnedLinks = pinnedLinks.length > 0;

  if (!hasPinnedLinks) {
    return null;
  }

  return (
    <div className={c.contentSection}>
      <h2 className={c.subheading}>Popular links</h2>
      <div className={c.links}>
        {sortedPinnedLinks.map((link, i) => (
          <SearchResultsCard entity={link} key={`pinned-${i}`} index={i} />
        ))}
      </div>
    </div>
  );
};
